<template>
  <div>
    <div>
      <template v-if="$route.query.request">
        <div class="notification notification-notice" style="padding:10px 15px 35px 15px;">
          <div class="notification-inner">
            <span class="notification-icon"></span>
            <span class="notification-text">{{$t('homeRequestSuccessfulMessage')}}</span>
            <a @click="hideSuccessMessage" class="notification-dismiss" data-notification-dismiss></a>
          </div>
        </div>
      </template>
    </div>
    <component v-bind:is="headerComponent"></component>
    <div>
      <ul class="row-container row-container--l category-boxes cf">
        <li @click="trackPageClick('using_sitename')" class="category-boxes__item">
          <router-link class="category-boxes__item__link" :to="{name: 'using-site'}">
            <h3 class="title">{{categories[getCategoryIdByName('using-site')].title}}</h3>
            <svg
              class="icon"
              width="50px"
              height="50px"
              viewBox="0 0 60 60"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>Payment & Billing</title>
              <path
                d="M9,34H27a1,1,0,0,0,0-2H9a1,1,0,0,0,0,2H9Zm26-4a1,1,0,0,0,0-2H27a1,1,0,0,0,0,2h8ZM9,30H23a1,1,0,0,0,0-2H9a1,1,0,0,0,0,2H9ZM59,18H5a1,1,0,0,0,0,2H58V39a3,3,0,0,1-3,3H5a3,3,0,0,1-3-3V17a1,1,0,0,0-2,0V39a5,5,0,0,0,5,5H55a5,5,0,0,0,5-5V19a1,1,0,0,0-1-1h0ZM60,5V15a1,1,0,0,1-2,0V5a3,3,0,0,0-3-3H5A3,3,0,0,0,2,5v5H55a1,1,0,0,1,0,2H1a1,1,0,0,1-1-1V5A5,5,0,0,1,5,0H55a5,5,0,0,1,5,5h0Z"
              />
            </svg>
            <p class="text" v-html="categories[getCategoryIdByName('using-site')].body"></p>
          </router-link>
        </li>

        <li @click="trackPageClick('billing_support')" class="category-boxes__item">
          <router-link class="category-boxes__item__link" :to="{name: 'billing-support'}">
            <h3 class="title">{{categories[getCategoryIdByName('billing-support')].title}}</h3>
            <svg
              class="icon"
              width="50px"
              height="50px"
              viewBox="0 0 40 40"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <title>House Icon</title>
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g transform="translate(2.000000, 0.000000)" fill="#000000">
                  <polygon points="18 0 0 9.20842361 0 13 18 13 36 13 36 9.20842361" />
                  <polygon points="26 29 32 29 32 16 26 16" />
                  <polygon points="15 29 21 29 21 16 15 16" />
                  <polygon points="4 29 10 29 10 16 4 16" />
                  <polygon points="0 39 36 39 36 33 0 33" />
                </g>
              </g>
            </svg>
            <p class="text" v-html="categories[getCategoryIdByName('billing-support')].body"></p>
          </router-link>
        </li>

        <li @click="trackPageClick('account_support')" class="category-boxes__item">
          <router-link class="category-boxes__item__link" :to="{name: 'account-support'}">
            <h3 class="title">{{categories[getCategoryIdByName('account-support')].title}}</h3>
            <svg
                    class="icon"
                    width="50px"
                    height="50px"
                    viewBox="0 0 60 60"
                    xmlns="http://www.w3.org/2000/svg"
            >
              <title>account</title>
              <path
                      d="M60,30A30,30,0,0,1,30,60,30.33,30.33,0,0,1,5.7,47.62a1,1,0,0,1-.14-1A1,1,0,0,1,6.48,46H48a1,1,0,0,1,0,2H8.55A28,28,0,0,0,58,30,28,28,0,0,0,2,30,27.71,27.71,0,0,0,5,42.62a1,1,0,1,1-1.79.9A29.69,29.69,0,0,1,0,30a30,30,0,0,1,60,0M42.49,10.67a1,1,0,0,1-1.37.36A22,22,0,0,0,8,30a19.77,19.77,0,0,0,3.79,12.39,1,1,0,0,1-1.58,1.22A22,22,0,0,1,6,30,24,24,0,0,1,42.14,9.3a1,1,0,0,1,.36,1.37m10,6.33a1,1,0,0,1-.37,1.37l-3.46,2a1,1,0,1,1-1-1.73l3.46-2a1,1,0,0,1,1.37.37m2.6,6.27a1,1,0,0,1-.71,1.22l-3.86,1a1,1,0,0,1-.26,0,1,1,0,0,1-.26-2l3.86-1a1,1,0,0,1,1.22.71M51,29h4a1,1,0,0,1,0,2H51a1,1,0,0,1,0-2M30,32a2,2,0,1,1,2-2,2,2,0,0,1-2,2M46.29,12.29L32,26.57A4,4,0,0,0,30,26a4,4,0,0,0-4,4,4,4,0,0,0,.57,2l-3.27,3.27a1,1,0,1,0,1.41,1.41L28,33.43A4,4,0,0,0,30,34a4,4,0,0,0,4-4,4,4,0,0,0-.57-2L47.71,13.71a1,1,0,0,0-1.41-1.41"
              ></path>
            </svg>
            <p class="text" v-html="categories[getCategoryIdByName('account-support')].body"></p>
          </router-link>
        </li>

        <li @click="trackPageClick('competition_details')" class="category-boxes__item">
          <router-link class="category-boxes__item__link" :to="{name: 'competition-details'}">
            <h3 class="title">{{categories[getCategoryIdByName('competition-details')].title}}</h3>
            <svg width="50" height="50" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon">
              <title>Competition Details</title>
              <path d="M29.6262 24.394L29.2148 26.7915C29.1772 27.0109 29.2674 27.2327 29.4474 27.3635C29.6275 27.4943 29.8661 27.5117 30.0633 27.408L32.2166 26.2761L34.3697 27.408C34.4553 27.453 34.5487 27.4752 34.6417 27.4752C34.7631 27.4752 34.8837 27.4375 34.9855 27.3634C35.1656 27.2326 35.2559 27.0109 35.2181 26.7915L34.807 24.3939L36.5489 22.6959C36.7083 22.5405 36.7656 22.3081 36.6968 22.0964C36.6281 21.8847 36.4451 21.7304 36.2248 21.6984L33.8175 21.3485L32.7409 19.1672C32.6423 18.9676 32.439 18.8412 32.2164 18.8412C31.9938 18.8412 31.7905 18.9676 31.692 19.1672L30.6152 21.3485L28.208 21.6984C27.9878 21.7304 27.8047 21.8848 27.7359 22.0964C27.6671 22.308 27.7245 22.5405 27.8838 22.6959L29.6262 24.394ZM31.088 22.4618C31.2784 22.4342 31.4431 22.3145 31.5282 22.1419L32.2166 20.7473L32.9048 22.1419C32.99 22.3145 33.1546 22.4341 33.345 22.4618L34.884 22.6854L33.7704 23.7711C33.6325 23.9054 33.5697 24.0989 33.6023 24.2887L33.8651 25.8213L32.4887 25.0977C32.4035 25.053 32.3101 25.0306 32.2166 25.0306C32.1232 25.0306 32.0297 25.053 31.9444 25.0977L30.5679 25.8213L30.8309 24.2887C30.8635 24.0989 30.8005 23.9054 30.6628 23.771L29.5491 22.6854L31.088 22.4618Z" fill="#3BB4EF"/>
              <path d="M4.98615 18.5345L4.57484 20.932C4.53717 21.1514 4.62739 21.3732 4.80743 21.504C4.98748 21.6349 5.22616 21.6522 5.42328 21.5485L7.57655 20.4166L9.72966 21.5485C9.81528 21.5935 9.90869 21.6157 10.0017 21.6157C10.123 21.6157 10.2437 21.578 10.3455 21.5039C10.5256 21.3731 10.6158 21.1514 10.5781 20.932L10.1669 18.5344L11.9089 16.8364C12.0683 16.681 12.1256 16.4486 12.0568 16.2369C11.988 16.0252 11.805 15.8709 11.5848 15.8389L9.17745 15.4891L8.10085 13.3077C8.00229 13.1081 7.79901 12.9817 7.57639 12.9817C7.35377 12.9817 7.15049 13.1081 7.05193 13.3077L5.97518 15.489L3.56795 15.8389C3.34775 15.8709 3.16466 16.0253 3.09589 16.2369C3.02712 16.4485 3.08451 16.681 3.24381 16.8364L4.98615 18.5345ZM6.44794 16.6024C6.63836 16.5748 6.80304 16.4551 6.88819 16.2824L7.57655 14.8879L8.26475 16.2824C8.34998 16.4551 8.51458 16.5747 8.705 16.6024L10.244 16.826L9.13035 17.9116C8.99249 18.046 8.92964 18.2395 8.96224 18.4292L9.22509 19.9619L7.84868 19.2383C7.76345 19.1935 7.67004 19.1712 7.57655 19.1712C7.48313 19.1712 7.38964 19.1935 7.30442 19.2383L5.92793 19.9619L6.19086 18.4293C6.22345 18.2395 6.16053 18.046 6.02275 17.9116L4.90911 16.826L6.44794 16.6024Z" fill="#3BB4EF"/>
              <path d="M16.6329 3.87956V4.59045C16.6329 6.25966 17.8463 7.64987 19.4371 7.92792V9.56828C18.004 9.80158 16.8679 10.9286 16.6206 12.357H15.8021C15.0479 12.357 15.0479 13.5266 15.8021 13.5266H24.1981C24.9524 13.5266 24.9524 12.357 24.1981 12.357H23.3557C23.1122 10.9512 22.0079 9.8376 20.6068 9.58036V7.92785C22.1977 7.64987 23.4111 6.25958 23.4111 4.59037V3.8734C24.1577 3.77296 24.7511 3.47307 25.179 2.97716C26.0449 1.97354 25.8469 0.55877 25.8381 0.49912C25.7955 0.212407 25.5494 3.8147e-06 25.2595 3.8147e-06H22.8262H22.7982H17.2177C17.2151 3.8147e-06 17.2126 0.000393688 17.2099 0.000393688C17.2073 0.000393688 17.2048 3.8147e-06 17.2021 3.8147e-06H14.7407C14.4508 3.8147e-06 14.2047 0.212407 14.1622 0.49912C14.1534 0.558848 13.9554 1.97354 14.8213 2.97716C15.2575 3.4829 15.8654 3.78521 16.6329 3.87956ZM22.1599 12.357H17.8163C18.0744 11.3997 18.9503 10.6929 19.9882 10.6929C21.0259 10.6929 21.9018 11.3996 22.1599 12.357ZM24.2933 2.21316C24.087 2.45231 23.7913 2.61091 23.411 2.68795V1.16962H24.6847C24.6572 1.48846 24.564 1.89939 24.2933 2.21316ZM17.8025 1.16962H22.2414V3.25903C22.2388 3.28133 22.2371 3.30395 22.2371 3.32703C22.2371 3.35011 22.2388 3.37264 22.2414 3.39502V4.59045C22.2414 5.81419 21.2458 6.80984 20.0219 6.80984C18.7981 6.80984 17.8025 5.81419 17.8025 4.59045V1.16962V1.16962ZM16.6329 1.16962V2.69606C16.234 2.62307 15.9248 2.46346 15.711 2.21792C15.4372 1.90383 15.3433 1.49018 15.3156 1.16962H16.6329V1.16962Z" fill="#3BB4EF"/>
              <path d="M39.3767 38.8304H38.4736V31.1677C38.4736 30.3385 37.7992 29.6641 36.9704 29.6641H26.9079C26.7641 29.6641 26.6254 29.6856 26.4936 29.7235V17.3767C26.4936 16.5476 25.8194 15.8731 24.9907 15.8731H14.9283C14.0997 15.8731 13.4255 16.5476 13.4255 17.3767V23.5929C13.3181 23.5684 13.2068 23.5543 13.0921 23.5543H3.0297C2.20083 23.5543 1.5265 24.2286 1.5265 25.0576V29.6294C1.5265 30.3836 2.69612 30.3836 2.69612 29.6294V25.0576C2.69612 24.8736 2.84576 24.7239 3.0297 24.7239H13.092C13.2759 24.7239 13.4254 24.8736 13.4254 25.0576V38.8304H2.69612V32.5144C2.69612 31.7602 1.5265 31.7602 1.5265 32.5144V38.8304H0.623323C0.300274 38.8304 0.0385132 39.0921 0.0385132 39.4152C0.0385132 39.7382 0.300274 40 0.623323 40H39.3767C39.6998 40 39.9616 39.7382 39.9616 39.4152C39.9616 39.0921 39.6997 38.8304 39.3767 38.8304ZM14.5951 38.8304V25.0576V17.3767C14.5951 17.1926 14.7445 17.0427 14.9282 17.0427H24.9907C25.1744 17.0427 25.324 17.1926 25.324 17.3767V38.8305H14.5951V38.8304ZM26.5745 38.8304V31.1677C26.5745 30.9836 26.7241 30.8337 26.9079 30.8337H36.9703C37.1542 30.8337 37.3039 30.9836 37.3039 31.1677V38.8304H26.5745Z" fill="#3BB4EF"/>
            </svg>

            <p class="text" v-html="categories[getCategoryIdByName('competition-details')].body"></p>
          </router-link>
        </li>
        <li @click="trackPageClick('judging_details')" class="category-boxes__item">
          <router-link class="category-boxes__item__link" :to="{name: 'judging-details'}">
            <h3 class="title">{{categories[getCategoryIdByName('judging-details')].title}}</h3>
            <svg width="50" height="50" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon">
              <title>Partners & Authors</title>
              <path d="M19.1736 31.2639C19.1124 31.2733 19.0538 31.2947 19.0009 31.3269C18.9481 31.359 18.9021 31.4013 18.8657 31.4513C18.8293 31.5013 18.8031 31.558 18.7888 31.6182C18.7744 31.6783 18.772 31.7407 18.7818 31.8018C18.7917 31.8629 18.8135 31.9214 18.8461 31.974C18.8786 32.0266 18.9213 32.0722 18.9715 32.1082C19.0218 32.1443 19.0787 32.17 19.139 32.184C19.1992 32.1979 19.2616 32.1998 19.3226 32.1895C19.5466 32.1536 19.7731 32.1356 20 32.1357C20.1243 32.1357 20.2435 32.0864 20.3314 31.9984C20.4194 31.9105 20.4687 31.7913 20.4687 31.667C20.4687 31.5427 20.4194 31.4234 20.3314 31.3355C20.2435 31.2476 20.1243 31.1982 20 31.1982C19.7232 31.1982 19.4469 31.2202 19.1736 31.2639V31.2639Z" fill="#3BB4EF"/>
              <path d="M38.6145 24.4611H38.5006L33.1256 11.5314H35.2571C35.5359 11.7989 35.8876 11.978 36.268 12.0459C36.6483 12.1139 37.0403 12.0678 37.3945 11.9135C37.7487 11.7591 38.0493 11.5034 38.2584 11.1785C38.4675 10.8536 38.5758 10.4741 38.5696 10.0877C38.5634 9.7014 38.443 9.32555 38.2236 9.00751C38.0042 8.68948 37.6956 8.44349 37.3366 8.30054C36.9777 8.1576 36.5844 8.12408 36.2064 8.20421C35.8285 8.28435 35.4827 8.47455 35.2126 8.75086H26.4759C26.279 8.52708 26.0367 8.34783 25.7651 8.22505C25.4935 8.10227 25.1989 8.03879 24.9008 8.03883H21.3906V4.83062C21.6627 4.55618 21.8475 4.20735 21.9216 3.82808C21.9958 3.44882 21.956 3.05609 21.8073 2.69938C21.6587 2.34267 21.4078 2.03795 21.0862 1.8236C20.7647 1.60925 20.3869 1.49487 20.0004 1.49487C19.614 1.49487 19.2362 1.60925 18.9146 1.8236C18.5931 2.03795 18.3421 2.34267 18.1935 2.69938C18.0448 3.05609 18.005 3.44882 18.0792 3.82808C18.1534 4.20735 18.3381 4.55618 18.6102 4.83062V8.03812H15.0992C14.8012 8.03808 14.5065 8.10157 14.2349 8.22435C13.9633 8.34712 13.721 8.52638 13.5242 8.75016H4.78743C4.51735 8.47374 4.17149 8.28344 3.79344 8.20324C3.41539 8.12305 3.02206 8.15653 2.663 8.29949C2.30395 8.44244 1.99524 8.68846 1.77577 9.00656C1.55629 9.32466 1.43587 9.7006 1.42969 10.087C1.4235 10.4734 1.53181 10.853 1.74099 11.178C1.95016 11.503 2.25084 11.7587 2.60513 11.9131C2.95942 12.0675 3.35148 12.1136 3.7319 12.0455C4.11233 11.9775 4.4641 11.7983 4.7429 11.5307H6.87447L1.49947 24.4604H1.38556C1.26124 24.4604 1.14201 24.5098 1.0541 24.5977C0.966195 24.6856 0.916809 24.8048 0.916809 24.9291C0.916809 28.3271 3.8815 31.0916 7.52556 31.0916C11.1696 31.0916 14.1342 28.3271 14.1342 24.9291C14.1342 24.8048 14.0848 24.6856 13.9969 24.5977C13.909 24.5098 13.7898 24.4604 13.6655 24.4604H13.5517L8.17665 11.5307H13.5243C13.7212 11.7545 13.9634 11.9338 14.235 12.0566C14.5066 12.1794 14.8013 12.2429 15.0993 12.2428H18.6099V29.623C16.2205 30.1209 14.3506 31.8709 13.9811 34.0627H13.8018C13.0797 34.0635 12.3874 34.3507 11.8768 34.8613C11.3662 35.3719 11.0789 36.0642 11.0781 36.7863V38.0351C11.0781 38.1594 11.1275 38.2786 11.2154 38.3665C11.3033 38.4544 11.4226 38.5038 11.5469 38.5038H28.4531C28.5775 38.5038 28.6967 38.4544 28.7846 38.3665C28.8725 38.2786 28.9219 38.1594 28.9219 38.0351V36.7863C28.9211 36.0642 28.6339 35.3719 28.1233 34.8612C27.6127 34.3506 26.9204 34.0634 26.1983 34.0627H26.0186C25.6492 31.8705 23.7798 30.1205 21.39 29.6229V12.2428H24.9008C25.1989 12.2429 25.4935 12.1794 25.7651 12.0566C26.0367 11.9338 26.279 11.7545 26.4758 11.5307H31.8235L26.4485 24.4604H26.3346C26.2103 24.4604 26.0911 24.5098 26.0032 24.5977C25.9153 24.6856 25.8659 24.8048 25.8659 24.9291C25.8659 28.3271 28.8305 31.0916 32.4745 31.0916C36.1186 31.0916 39.0833 28.3271 39.0833 24.9291C39.0831 24.8049 39.0336 24.6859 38.9457 24.5981C38.8578 24.5104 38.7387 24.4611 38.6145 24.4611V24.4611ZM36.6106 9.09844C36.8124 9.09842 37.0096 9.15824 37.1774 9.27031C37.3452 9.38239 37.4759 9.5417 37.5531 9.72809C37.6303 9.91449 37.6506 10.1196 37.6112 10.3175C37.5719 10.5154 37.4747 10.6971 37.3321 10.8398C37.1894 10.9825 37.0076 11.0796 36.8098 11.119C36.6119 11.1584 36.4068 11.1382 36.2204 11.061C36.034 10.9837 35.8747 10.853 35.7626 10.6852C35.6505 10.5175 35.5906 10.3203 35.5906 10.1185C35.591 9.84808 35.6985 9.58881 35.8897 9.39758C36.0809 9.20635 36.3402 9.09877 36.6106 9.09844V9.09844ZM3.38939 11.1386C3.18763 11.1386 2.9904 11.0788 2.82264 10.9667C2.65488 10.8546 2.52412 10.6953 2.4469 10.5089C2.36968 10.3225 2.34947 10.1174 2.38882 9.91956C2.42817 9.72167 2.52532 9.53991 2.66798 9.39724C2.81063 9.25457 2.9924 9.15741 3.19027 9.11804C3.38815 9.07868 3.59326 9.09887 3.77966 9.17608C3.96606 9.25328 4.12538 9.38403 4.23747 9.55178C4.34956 9.71954 4.40939 9.91676 4.40939 10.1185C4.40908 10.3889 4.30152 10.6482 4.1103 10.8394C3.91908 11.0307 3.65982 11.1383 3.38939 11.1386V11.1386ZM7.52556 30.1542C5.19954 30.1542 3.19697 28.8573 2.32314 27.0073H12.7279C11.8541 28.8573 9.85158 30.1544 7.52556 30.1544V30.1542ZM13.0595 26.0698H1.99157C1.93753 25.8488 1.89921 25.6243 1.87689 25.3979H13.1738C13.1516 25.6243 13.1134 25.8489 13.0595 26.0699V26.0698ZM12.536 24.4604H2.5147L7.52556 12.4069L12.536 24.4604ZM5.28806 10.5932C5.36256 10.2964 5.36617 9.98615 5.29861 9.68766H13.0469C12.9807 9.98588 12.9807 10.295 13.0469 10.5932H5.28806ZM20 2.43398C20.2018 2.43398 20.399 2.49381 20.5667 2.6059C20.7345 2.71799 20.8652 2.8773 20.9424 3.06369C21.0197 3.25009 21.0399 3.45519 21.0005 3.65307C20.9611 3.85094 20.864 4.03271 20.7213 4.17537C20.5787 4.31803 20.3969 4.41518 20.199 4.45454C20.0011 4.4939 19.796 4.4737 19.6096 4.39649C19.4233 4.31928 19.2639 4.18854 19.1518 4.02079C19.0398 3.85304 18.9799 3.65581 18.9799 3.45406C18.9802 3.18361 19.0878 2.92432 19.279 2.73308C19.4703 2.54184 19.7296 2.43427 20 2.43398V2.43398ZM20.4531 5.3582V8.03789H19.5477V5.3582C19.8453 5.42945 20.1555 5.42945 20.4531 5.3582ZM25.0652 34.0627H24.0625C23.9382 34.0627 23.819 34.112 23.7311 34.2C23.6432 34.2879 23.5938 34.4071 23.5938 34.5314C23.5938 34.6557 23.6432 34.775 23.7311 34.8629C23.819 34.9508 23.9382 35.0002 24.0625 35.0002H26.1983C26.4329 35.0001 26.6651 35.0463 26.8818 35.1361C27.0985 35.2259 27.2954 35.3574 27.4613 35.5233C27.6271 35.6891 27.7587 35.886 27.8485 36.1027C27.9382 36.3194 27.9844 36.5517 27.9844 36.7863V37.5663H12.0156V36.7863C12.0156 36.5517 12.0618 36.3194 12.1516 36.1027C12.2413 35.886 12.3729 35.6891 12.5388 35.5233C12.7046 35.3574 12.9015 35.2259 13.1182 35.1361C13.3349 35.0463 13.5672 35.0001 13.8017 35.0002H20.9375C21.0618 35.0002 21.1811 34.9508 21.269 34.8629C21.3569 34.775 21.4063 34.6557 21.4063 34.5314C21.4063 34.4071 21.3569 34.2879 21.269 34.2C21.1811 34.112 21.0618 34.0627 20.9375 34.0627H16.7177C16.7211 34.0554 16.7256 34.0487 16.7284 34.0411C16.9388 33.5153 17.3418 33.0567 17.8947 32.7136C18.0013 32.6506 18.0796 32.5491 18.1137 32.4301C18.1477 32.311 18.1348 32.1835 18.0776 32.0737C18.0468 32.0186 18.0052 31.9703 17.9553 31.9317C17.9053 31.893 17.8481 31.8649 17.7871 31.8489C17.726 31.833 17.6623 31.8295 17.5999 31.8387C17.5374 31.848 17.4775 31.8697 17.4237 31.9027C16.6878 32.3532 16.1464 32.9722 15.8581 33.6927C15.8344 33.7518 15.823 33.8151 15.8247 33.8787C15.8264 33.9423 15.841 34.0049 15.8677 34.0627H14.9346C15.3728 31.9822 17.4937 30.417 20 30.417C22.5063 30.417 24.6271 31.982 25.0652 34.0627V34.0627ZM19.5473 29.4959V12.2428H20.4531V29.4959C20.3035 29.4861 20.1527 29.4795 20 29.4795C19.8473 29.4795 19.697 29.4861 19.5473 29.4959V29.4959ZM24.9008 11.3052H15.0992C14.7903 11.3052 14.494 11.1825 14.2756 10.9641C14.0571 10.7456 13.9344 10.4493 13.9344 10.1404C13.9344 9.83145 14.0571 9.53517 14.2756 9.31672C14.494 9.09827 14.7903 8.97555 15.0992 8.97555H24.9008C25.2097 8.97555 25.506 9.09827 25.7245 9.31672C25.9429 9.53517 26.0656 9.83145 26.0656 10.1404C26.0656 10.4493 25.9429 10.7456 25.7245 10.9641C25.506 11.1825 25.2097 11.3052 24.9008 11.3052V11.3052ZM26.9531 10.5932C27.0193 10.295 27.0193 9.98588 26.9531 9.68766H34.7011C34.6334 9.98613 34.6369 10.2963 34.7113 10.5932H26.9531ZM32.4742 12.4069L37.4853 24.4611H27.4637L32.4742 12.4069ZM32.4742 30.1544C30.1482 30.1544 28.1456 28.8575 27.2718 27.0074H37.6769C36.8031 28.8573 34.8005 30.1544 32.4745 30.1544H32.4742ZM38.0081 26.0699H26.9406C26.8865 25.849 26.8482 25.6244 26.8259 25.398H38.1231C38.1008 25.6244 38.0625 25.849 38.0085 26.0699H38.0081Z" fill="#3BB4EF"/>
            </svg>
            <p class="text" v-html="categories[getCategoryIdByName('judging-details')].body"></p>
          </router-link>
        </li>
      </ul>
    </div>
    <component v-bind:is="footerComponent"></component>
  </div>
</template>

<script>
import { getComponent, getCategoryPageName, getCategoryIdByName, trackPageView, trackPageClick } from '@/utils/common';

export default {
  name: 'home',
  metaInfo() {
    return {
      titleTemplate: `%s`
    };
  },
  created() {
    if (this.$route.query.request) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }
    trackPageView('home');
  },
  computed: {
    categories() {
      return this.$store.state.categories;
    },
    articles() {
      return this.$store.state.articles;
    },
    // Getting Component Dynamically & Asynchronously
    headerComponent() {
      return getComponent(this.$store.getters.flowObject, 'header');
    },
    footerComponent() {
      return getComponent(this.$store.getters.flowObject, 'footer');
    }
  },
  methods: {
    getCategoryPageName(catId) {
      return getCategoryPageName(catId, this.$store.getters.flowObject.pages);
    },
    getCategoryIdByName(catName) {
      return getCategoryIdByName(catName);
    },
    hideSuccessMessage() {
      this.$router.push({ path: window.location.pathname });
    },
    trackPageClick(clickName) {
      return trackPageClick(clickName);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/global.scss';

.category-boxes {
  list-style-type: none;
  padding: 0;
  font-size: 0.9rem;
  font-weight: 300;
  padding: 0 5%;
  justify-content: center;
  @media (min-width: 600px) {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;

    color: #2b2b2b;
  }
  @media (min-width: 960px) {
    font-size: 1rem;
  }
  @media (min-width: 1160px) {
    padding: 0;
    width: 90%;
  }
}
.category-boxes__item {
  margin-bottom: 2rem;
  padding: 0 1rem;
}
.category-boxes__item__link {
  text-align: center;
  border: 1px solid #888;
  text-decoration: none;
  margin: 0 auto;
  line-height: 1.5rem;
  border-radius: 3px;
  padding: 1rem;
  display: block;
  height: 100%;
  max-width: 28.3rem;

  .title {
    color: #2b2b2b;
    font-weight: 700 !important;
    transition: 0.2s linear all;
    line-height: 27px;
    margin: 0 0 0.3rem 0;
  }

  .icon {
    width: 27px;
    polygon,
    path {
      transition: 0.2s linear all;
      fill: $theme-highlight;
    }
  }

  .text {
    margin: 0;
    font-size: 13px;
    line-height: 1.5;
    color: #2b2b2b;
  }

  &:hover {
    background-color: $theme-highlight;
    color: #fff;

    .title,
    .text {
      color: #fff;
    }
    .icon {
      polygon,
      path {
        fill: #fff;
      }
    }
  }
}

@media (min-width: 641px) {
  .category-boxes__item__link {
    padding: 1.5em;

    .title {
      margin-top: 0.6rem;
      margin-bottom: 1rem;
      font-size: 1.1rem;
    }
    .icon {
      width: 40px;
    }
    .text {
      margin-top: 1.1rem;
      font-size: 1rem;
    }
  }
}
.category-boxes__item {
  width: 100%;
}
@media (min-width: 40em) {
  .category-boxes__item {
    width: calc(50% - 2px);
  }
}
@media (min-width: 52em) {
  .category-boxes__item {
    width: calc(33.3% - 2px);
    margin-bottom: 2em;
  }
}
@media (min-width: 73em) {
  .category-boxes__item {
    width: calc(20% - 2px);
  }
}
.notification-inner {
  position: relative;
  margin: 0 auto;
  padding: 0 20px;
  max-width: 980px;
}
.notification {
  border: 1px solid;
  display: table;
  font-family: sans-serif;
  font-size: 12px;
  padding: 10px 15px 15px 15px !important;
  margin: 0px 0px 160px 0px !important;
  transition: height 0.2s;
  width: 100%;
  color: #555;
  text-align: center;
}
.notification-notice {
  background: #dbf3ff;
}

.notification-text {
  padding-left: 15px;
  padding-right: 5px;
  width: 100%;
  display: block;
  text-align: left;
}

.notification-dismiss,
.notification-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  text-decoration: none;
}

.notification-dismiss {
  cursor: pointer;
  right: 0;
}

.notification-icon {
  left: 0;
}

.notification-dismiss::before {
  display: inline-block;
  line-height: 20px;
  text-align: center;
  width: 20px;
}

.notification-dismiss::before {
  color: #000;
  color: initial;
  content: '\2715';
  font-family: sans-serif;
  font-size: 16px;
  opacity: 0.6;
  transition: opacity 100ms ease;
  text-decoration: none !important;
}
.notification-icon::before {
  content: '\2713';
  display: inline-block;
  line-height: 20px;
  text-align: center;
  width: 20px;
  border: 1px solid #b5e0f5;
  border-radius: 50%;
  font-family: 'entypo';
}
</style>
